export const regionOptions = [
  "全部地区",
  "中国大陆",
  "中国香港",
  "中国台湾",
  "日本",
  "韩国",
  "英国",
];

export const decadeOptions = ["全部年代", "2020年代", "2010年代"];

export const ratingOptions = ["全部评分", "9.0 分以上", "8.5 分以上", "8.0 分以上"];

export const sortOptions = [
  { value: "latest", label: "最新上线" },
  { value: "rating", label: "评分最高" },
  { value: "views", label: "最多浏览" },
];

export const episodeOptions = ["全部集数", "12 集以内", "13 - 24 集"];

export const articleTags = [
  "全部专题",
  "家庭伦理",
  "剧集解析",
  "悬疑伦理",
  "电影解析",
  "性别议题",
];

export const PAGE_SIZE = 6;